import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { incidentIdField } from './common/sharedFields';

export const healthAndSafetyIncidentsMetadata = {
  displayName: msg({
    message: 'Health and safety incidents',
    context: 'Activity data schema name for health and safety incidents',
  }),
  fields: {
    ...coreFields,
    employee_type: {
      displayName: msg({
        message: 'Health and safety incident employee type',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'The classification of worker involved in the health and safety incident.',
      }),
    },
    fatality_count: {
      displayName: msg({
        message: 'Fatalities count',
        context: 'The fatalities caused by the incident.',
      }),
      externalDescription: msg({
        message:
          'The number of fatalities resulting from a health and safety incident.',
      }),
    },
    incident_id: incidentIdField,
    incident_type: {
      displayName: msg({
        message: 'Incident type',
        context: 'The type of incident.',
      }),
      externalDescription: msg({
        message:
          'The classification or category of the health and safety incident.',
      }),
    },
    work_days_lost_count: {
      displayName: msg({
        message: 'Days lost count',
        context: 'The display name for a metric',
      }),
      externalDescription: msg({
        message:
          'The number of work days lost due to a health and safety incident.',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
